export enum HttpTimeoutPriority  {
  Lowest = 8000,
  Low = 12500,
  Medium = 18000,
  High = 22500,
  Highest = 30000,
}
